import React from "react";
import { Image, View, StatusBar, StyleSheet,  TouchableOpacity, Text } from "react-native";

const Layout = ({ children }) => {
  return (
    <View style={styles.container}>
      <Image
        style={styles.tinyLogo}
        source={require('../assets/logo.png')}
      />
      <StatusBar backgroundColor="#222f3e" />
      {children}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    paddingTop: 5,
    backgroundColor: "#222f3e",
    flex: 1,
    alignItems: "center",
    textAlign: "left"
  },
  title: {
    color: "#ffffff",
    fontSize: 20,
    textAlign: "left",
    marginTop: 10
  },
  tinyLogo: {
    width: 100,
    height: 100,
  },
});

export default Layout;
